import React, { useState } from 'react'
import Breadcrumb from '../../../Components/Breadcrumb/Breadcrumb'
import EvnVar from '../../../EnvVar'
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom'

const baseURL = EvnVar()

function EducatedIndividual() {
    const questions = {
        "question1": "1. Do you have a bank account?",
        "question2": "2. Do you hold PAN Card?",
        "question3": "3. Do you know how to use a debit card?",
        "question4": "4. Do you know how to use UPI?",
        "question5": "5. Are you aware about the government schemes that are associated with PAN Card?",
        "question6": "6. Do you follow the concept of monthly savings?",
        "question7": "7. Have you ever dealt with a financial crisis?",
        "question8": "8. Do you understand the process of taking loans?",
        "question9": "9. Do you have any long-term financial goals?",
        "question10": "10. Do you file Income Tax Return?",
    }

    const [currentActive, setCurrentActive] = useState('first')
    const [buttonDisabled, setButtonDisabled] = useState(true)
    const [buttonDisabled2, setButtonDisabled2] = useState(true)
    const [buttonDisabled3, setButtonDisabled3] = useState(true)
    const [buttonDisabled4, setButtonDisabled4] = useState(true)
    const [buttonDisabled5, setButtonDisabled5] = useState(true)
    const [directSubmit, setDirectSubmit] = useState(false)
    // const [buttonDisabled5, setButtonDisabled5] = useState(true)
    const [formData, setFormData] = useState({
        name: '',
        // number: '',
        city: '',
        occupation: '',
        question1: '',
        question2: '',
        question3: '',
        question4: '',
        question5: '',
        question6: '',
        question7: '',
        question8: '',
        question9: '',
        question10: '',
        numberVal: '',
        otp: '',
        testimonial: '',
    });

    const formChanges = (e) => {
        const { name, value } = e.target
        const updatedFormData = {
            ...formData,
            [name]: value,
        }

        // if (name === 'number') {
        //     updatedFormData.number = value.replace(/\D/g, '').slice(0, 10);
        // }

        if (name === 'numberVal') {
            updatedFormData.numberVal = value.replace(/\D/g, '').slice(0, 10);
        }

        if (name === 'otp') {
            updatedFormData.otp = value.replace(/\D/g, '').slice(0, 6);
        }

        setFormData(updatedFormData);

        if (updatedFormData.name !== '' && updatedFormData.city !== '' && updatedFormData.occupation !== '') {
            setButtonDisabled(false)
        } else {
            setButtonDisabled(true)
        }

        if (updatedFormData.question1 !== '' && updatedFormData.question2 !== '' && updatedFormData.question3 !== '' && updatedFormData.question4 !== '' && updatedFormData.question5 !== '' && updatedFormData.question6 !== '' && updatedFormData.question7 !== '' && updatedFormData.question8 !== '' && updatedFormData.question9 !== '' && updatedFormData.question10 !== '') {
            setButtonDisabled2(false)
        } else {
            setButtonDisabled2(true)
        }

        if (updatedFormData.numberVal !== '') {
            setButtonDisabled3(false)
        } else {
            setButtonDisabled3(true)
        }

        if (updatedFormData.otp !== '') {
            setButtonDisabled4(false)
        } else {
            setButtonDisabled4(true)
        }

        if (updatedFormData.testimonial !== '') {
            setButtonDisabled5(false)
        } else {
            setButtonDisabled5(true)
        }
    }

    const haveNoNumber = (e) => {
        if (e.target.checked) {
            setDirectSubmit(true)
            // console.log("Have no number checked");
        } else {
            setDirectSubmit(false)
            // console.log("Have no number unchecked");
        }
    }
    // console.log(formData);
    const token = Cookies.get("jwt");
    // OTP get API
    const otpSend = (e) => {
        e.preventDefault();
        const number = {
            mobile: formData.numberVal
        }
        console.log("Number sent for OTP", number, 'and iska type', typeof (number));

        // let mobileNumber = JSON.stringify(number);

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/otp`,
            headers: {
                'content-type': 'application/json',
                Authorization: token,

            },
            data: number,
            withCredentials: true,
        }

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                setCurrentActive('fourth')
            })
            .catch((error) => {
                console.log(error);
            });
    }

    // survey data post API
    const [surveyNumber, setSurveyNumber] = useState(undefined)
    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log('Form Data Submitted:', formData);
        // You can send formData to your server here

        let surveyData = JSON.stringify({
            "name": formData.name,
            "mobile": directSubmit ? null : formData.numberVal,
            "occupation": formData.occupation,
            "place": formData.city,
            "q1": formData.question1,
            "q2": formData.question2,
            "q3": formData.question3,
            "q4": formData.question4,
            "q5": formData.question5,
            "q6": formData.question6,
            "q7": formData.question7,
            "q8": formData.question8,
            "q9": formData.question9,
            "q10": formData.question10,
            "otp": directSubmit ? null : formData.otp,
        });

          console.log("surveyData", JSON.parse(surveyData));

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/survey`,
            headers: {
                'content-type': 'application/json',
                Authorization: token,

            },
            data: surveyData,
            withCredentials: true,
        }

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                // console.log("Survay number", response.data.survey);
                setSurveyNumber(response.data.survey)
                setCurrentActive('fifth')
            })
            .catch((error) => {
                console.log(error);
                alert(error.response.data.error)
            });
    }

    // testimonial post API
    const nagivate = useNavigate()
    const testimonialSubmit = (e) => {
        e.preventDefault();
        // console.log('formData.testimonial:', formData.testimonial);
        // console.log("surveyNumber", surveyNumber);

        let survayData = JSON.stringify({
            "survey_id": surveyNumber,
            "testimonial_text": formData.testimonial
        });

        //   console.log("survayData", JSON.parse(survayData));

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${baseURL}/dash/testimonials`,
            headers: {
                'content-type': 'application/json',
                Authorization: token,

            },
            data: survayData,
            withCredentials: true,
        }

        axios.request(config)
            .then((response) => {
                // console.log(JSON.stringify(response.data));
                nagivate('/ambassador/testimonials');
            })
            .catch((error) => {
                console.log(error);
            });
    }
    return (
        <>
            <Breadcrumb data="Financial Literate Individual" />
            <div className='content-body'>
                {currentActive == 'first' ? <div className='table-data'>
                    <form className="row g-3 needs-validation mb-4">
                        <div className="col-md-6">
                            <label htmlFor="name" className="form-label">Name</label>
                            <input type="text" className="form-control" id="name" name="name" placeholder="Enter name" onChange={formChanges} value={formData.name} required />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="city" className="form-label">City</label>
                            <input type="text" className="form-control" id="city" name="city" placeholder="Enter city" onChange={formChanges} value={formData.city} required />
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="occupation" className="form-label">Occupation</label>
                            <input type="text" className="form-control" id="occupation" name="occupation" placeholder="Enter occupation" onChange={formChanges} value={formData.occupation} required />
                        </div>

                        <div className="col-12" style={{ textAlign: "center" }}>
                            <button className="btn btn-primary download-btn" type="submit" onClick={() => setCurrentActive('second')} disabled={buttonDisabled}>Next</button>
                        </div>
                    </form>
                </div> : currentActive == 'second' ? <div className='table-data'>
                    <form className="row g-3 needs-validation mb-4">
                        {Object.keys(questions).map((key, index) => {
                            const [title, description] = questions[key].split('*');
                            return (
                                <div className="col-md-12" key={key}>
                                    <b>{title}</b>
                                    <p className='mt-1 mb-0'>{description}</p>
                                    <div className='d-flex align-items-center mt-2'>
                                        <div className="form-check me-4">
                                            <input className="form-check-input" type="radio" value="true" name={key} onChange={formChanges} id={`yes${index}`} />
                                            <label className="form-check-label" htmlFor={`yes${index}`}>
                                                Yes
                                            </label>
                                        </div>
                                        <div className='form-check'>
                                            <input className="form-check-input" type="radio" value="false" name={key} onChange={formChanges} id={`no${index}`} />
                                            <label className="form-check-label" htmlFor={`no${index}`}>
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </div>)
                        })}
                        <div className="col-12" style={{ textAlign: "center" }}>
                            <button className="btn btn-primary download-btn" type="submit" onClick={() => setCurrentActive('third')} disabled={buttonDisabled2}>Next</button>
                        </div>
                    </form>
                </div> : currentActive == 'third' ? <div className='table-data'>
                    <form className="row g-3 needs-validation mb-4 justify-content-center" onSubmit={directSubmit ? handleSubmit : otpSend}>
                        <div className="col-md-6">
                            <label htmlFor="numberVal" className="form-label">Mobile</label>
                            <input type="number" className="form-control" name="numberVal" id="numberVal" placeholder="Enter mobile" value={formData.numberVal} onChange={formChanges} />
                        </div>
                        <div className="col-md-12 justify-content-center d-flex">
                            <div className='col-md-6'>
                                <div className='d-flex'>
                                    <input type="checkbox" className="form-check-input p-2 me-2" name="isNumberAdd" id="isNumberAdd" onChange={haveNoNumber} />
                                    <label htmlFor="isNumberAdd" className="form-label">Does not have mobile number?</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-12" style={{ textAlign: "center" }}>
                            {directSubmit ? <button className="btn btn-primary download-btn" type="submit">Submit</button> : <button className="btn btn-primary download-btn" type="submit" disabled={buttonDisabled3}>Send OTP</button>}
                        </div>
                    </form>
                </div>
                    : currentActive == 'fourth' ? <div className='table-data'>
                        <form className="row g-3 needs-validation mb-4 justify-content-center" onSubmit={handleSubmit}>
                            <div className="col-md-6">
                                <label htmlFor="otp" className="form-label">OTP</label>
                                <input type="number" className="form-control" name="otp" id="otp" placeholder="Enter OTP" value={formData.otp} onChange={formChanges} required />
                            </div>
                            <div className="col-12" style={{ textAlign: "center" }}>
                                <button className="btn btn-primary download-btn" type="submit" disabled={buttonDisabled4}>Submit</button>
                            </div>
                        </form>
                    </div> : currentActive == 'fifth' ? <div className='table-data'>
                        <form className="row g-3 needs-validation mb-4 justify-content-center" onSubmit={testimonialSubmit}>
                            <div className="col-md-6">
                                <label htmlFor="testimonial" className="form-label">Testimonial</label>
                                <textarea type="text" rows={8} className="form-control" name="testimonial" id="testimonial" placeholder="Enter testimonial" value={formData.testimonial} onChange={formChanges} required />
                            </div>
                            <div className="col-12" style={{ textAlign: "center" }}>
                                <button className="btn btn-primary download-btn" type="submit" disabled={buttonDisabled5}>Create</button>
                            </div>
                        </form>
                    </div> : ""}
            </div>
        </>
    )
}

// onClick={() => setCurrentActive('fourth')}

export default EducatedIndividual
